import {
  getApiUrl,
  getToken,
  getApplication,
} from "../constants/settings.constant";

import http from "./http";

function getProfiles(params) {
  const api = getApiUrl();
  const token = getToken();
  const application = getApplication();

  return new Promise((resolve, reject) => {
    http
      .get(`${api}/configurations/${application}/profiles`, {
        headers: {
          application: application,
          "ticket-sso": token,
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function getTemplateSettings() {
  const api = getApiUrl();
  const token = getToken();
  const application = getApplication();

  return http.get(`${api}/configurations/template-settings`, {
    headers: {
      application: application,
      "ticket-sso": token,
    },
  });
}

function getMessageVisibilityOptions() {
  const api = getApiUrl();
  const token = getToken();
  const application = getApplication();

  return http.get(`${api}/configurations/message-visibility-options`, {
    headers: {
      application: application,
      "ticket-sso": token,
    },
  });
}

export default {
  getProfiles,
  getTemplateSettings,
  getMessageVisibilityOptions,
};
